/* eslint-disable no-console */
import moment from 'moment';
import { Languages } from './languages';
import { getDeep } from '..';
const langFileMissing = lang => {
    if (process.env.NODE_ENV !== 'production') {
        console.error(`No language files for ${lang} registered! You should supply it when creating a Translator.`);
    }
};
export class Translator {
    /**
     * @constructor
     * A translator to hold your translation-files and extract text based on dot-notated labels.
     * @param {Object} swedish
     * @param {Object} norwegian
     * @param {Object} danish
     * @param {Object} finnish
     */
    constructor(swedish, norwegian, danish, finnish) {
        if (!swedish) {
            langFileMissing('Swedish');
        }
        if (!norwegian) {
            langFileMissing('Danish');
        }
        if (!danish) {
            langFileMissing('Norwegian');
        }
        if (!finnish) {
            langFileMissing('Finnish');
        }
        this.currentLanguage = Languages.SWEDISH;
        this.labels = {
            [Languages.SWEDISH]: swedish,
            [Languages.NORWEGIAN]: norwegian,
            [Languages.DANISH]: danish,
            [Languages.FINNISH]: finnish,
        };
    }
    /**
     * @param {Languages} language
     */
    setLanguage(language) {
        if (Object.values(Languages).every(l => l !== language)) {
            console.log(`Unrecognized language: ${language}! Ignoring change.`);
            return;
        }
        this.currentLanguage = language;
        moment.locale(language);
    }
    /**
     * Uses this.currentLanguage to find a deeply nested label in the translations.
     * If match is not found in set language, it attempts to find a fallback in Swedish. Else empty string.
     *
     * @param {string} label Dot notation for a deeply rooted field.
     * @returns {string} Either the found string in the supplied language or a Swedish fallback or an empty string.
     * @example getText('my.translation.1')
     */
    getText(label) {
        const element = getDeep(this.labels[this.currentLanguage], label);
        const fallback = !element &&
            Languages.SWEDISH !== this.currentLanguage &&
            getDeep(this.labels[Languages.SWEDISH], label);
        return element || fallback || '';
    }
}
